import {Space} from "antd";
import {SubSettingsFormFields} from "../../general/settings/sub-settings";
import {LiveEventCloseRegistrationSettingFormField} from "./close-registration";

export function LiveEventSettingsFormFields({
  formType,
  showUrlRedirect = formType === "edit",
}: {
  formType: "create" | "edit";
  showUrlRedirect?: boolean;
}) {
  return (
    <Space size={16} direction="vertical" style={{display: "flex"}}>
      <LiveEventCloseRegistrationSettingFormField />
      {/*
        No purchase limit here, unlike digital products and product services. An event is
        capped by its seats — the checkout works out what is left from `attendees` minus
        the bookings taken — so a separate per-transaction cap is not a thing an event
        has, and the API carries no field for one.
      */}
      <SubSettingsFormFields
        requestCustomerPhoneNumberLabel="Request customer's phone number"
        hideFromProfileLabel="Hide event from your profile page "
        showUrlRedirect={showUrlRedirect}
      />
    </Space>
  );
}
